import NewTag from './NewTag'

export default NewTag
